import React, { useState } from 'react'
import leftMenu from '../../Images/leftMenu.png'
import closeMenu from '../../Images/closeMenu.png'
import Banner from '../../Images/Banner.png'
import telephone from '../../Images/telephone.png'
import book from '../../Images/book.png'
import locationimg from '../../Images/location.png'
import Banner2Logo from '../../ImagesLogos/Banner2Logo.png'
// import Logo from '../../Images/Logo.png'
import './Header.scss';
import Arrow from '../../Images/downArrow.png'
import { useLocation, useNavigate } from 'react-router-dom'

export default function Header({ CitiePhone, CitiesData, showMenu, setShowPopUp, setShowMenu }) {
    const [header, setHeader] = useState(false)
    const location = useLocation()
    const navigate = useNavigate()
    return (
        <div className="Header">
            {/* HeaderBottom */}
            <div className="HeaderBottom">
                <div className='Header2'>
                    <div className="Header2Location">
                        <img src={require(`../../Images/place.png`)} alt="" />
                        <h1>{CitiesData.City ? CitiesData.City.toUpperCase() : "Local"}</h1>
                    </div>

                </div>
                <div className="Header1Main">
                    <div className="Header2Circle">
                        <div className='circle'>
                            <span className='hdhs1'></span>
                            <span className='hdhs2'></span>
                        </div>
                        <h3>We Are Open</h3>
                    </div>
                    <div className='Header1'>
                        <a onClick={() => navigate(location.pathname.includes("chimney") ? `/book${location.search ? location.search + "&service=chimney" : "?service=chimney"}` : `/book${location.search}`)}>SCHEDULE <span>&nbsp;ONLINE</span><img src={book}alt="Air Duct Cleaning | Air Duct Repair | Air Duct Services | Air Duct Inspection In Master," /></a>
                    </div>
                    <div className='Header1'>
                        <a target='_blank' href={`tel:${CitiePhone}`}>CALL <span>&nbsp;{CitiePhone}</span><img src={telephone} alt="Air Duct Cleaning | Air Duct Repair | Air Duct Services | Air Duct Inspection In Master," /></a>
                    </div>
                </div>
            </div>
            {/* HeaderTopComputer */}
            <div className="HeaderTopComputer">
                <div className="Header2" >
                    <div className="Header2Logo">
                        <img src={Banner2Logo} alt="Air Duct Cleaning | Air Duct Repair | Air Duct Services | Air Duct Inspection In Master," />
                    </div>
                    <div className="Header2LogoName">
                        <h1>MASTER AIR DUCT</h1>
                        <h2>Your Local Air Duct Company</h2>
                    </div>
                </div>

                <div className="Header1">
                    <div className="Header1Box">
                        <div className="Header1BoxHedaer">
                            <a onClick={() => {
                                window.scrollTo(0, 0)
                                navigate(`/${location.search}`)
                            }
                            }>HOME PAGE</a>
                        </div>
                    </div>
                    <div className="Header1Box">
                        <div className="Header1BoxHedaer">
                            {location.pathname == "/book" ?
                                <a href={`/${location.search}#ourservices`}>OUR SERVICES</a>
                                :
                                <a onClick={() => window.location.hash = 'ourservices'}>OUR SERVICES</a>
                            }
                        </div>
                    </div>
                    <div className="Header1Box">
                        <div className="Header1BoxHedaer">
                            {location.pathname == "/book" ?
                                <a href={`/${location.search}#reviews`}>REVIEWS &gt;</a>
                                :
                                <a onClick={() => window.location.hash = 'reviews'}>REVIEWS &gt;</a>
                            }
                        </div>
                    </div>
                    <div className="Header1Box">
                        <div className="Header1BoxHedaer">
                            {location.pathname == "/book" ?
                                <a href={`/${location.search}#contact`}>CONTACT US</a>
                                :
                                <a onClick={() => window.location.hash = 'contact'}>CONTACT US</a>
                            }
                        </div>
                    </div>
                </div>
            </div>
            {/* HeaderTopPhone */}
            <div className="HeaderTopPhone">
                <div className="Header2" >
                    <div className="Header2Logo">
                        <img src={Banner2Logo} alt="Air Duct Cleaning | Air Duct Repair | Air Duct Services | Air Duct Inspection In Master," />
                    </div>
                    <div className="Header2LogoName">
                        <a href="/">MASTER AIR DUCT</a>
                        <p>Your Local Air Duct Company</p>
                    </div>
                </div>
                <div className='Header3'>
                    <div className="Header2Circle" onClick={() => { setShowPopUp(true) }}>
                        <div className='circle'>
                            <span className='hdhs1'></span>
                            <span className='hdhs2'></span>
                        </div>
                        <h3>We Are Open</h3>
                    </div>
                    {showMenu ?
                        <img
                            // style={header ? { "filter": "invert(1)", "width": "30px" } : { "filter": "invert(1)", "width": "30px" }}
                            src={closeMenu} alt="Air Duct Cleaning | Air Duct Repair | Air Duct Services | Air Duct Inspection In Master,"
                            className='menuCloseBtn'
                            onClick={() => setShowMenu(false)}
                        />
                        :
                        <img
                            // style={header ? { "filter": "invert(1)" } : { "filter": "invert(1)" }}
                            src={leftMenu} alt="Air Duct Cleaning | Air Duct Repair | Air Duct Services | Air Duct Inspection In Master,"
                            onClick={() => setShowMenu(true)}
                        />
                    }

                </div>
            </div>

        </div>
    )
}
